export const formatPlate = (plate: string): string =>
  plate ? plate.replace(/[^a-zA-Z0-9]/g, "").toUpperCase() : "";

export const isValidPlate = (plate: string): boolean => {
  const formattedPlate = formatPlate(plate);
  return formattedPlate.length === 7;
};
